import styled from 'styled-components';
import { Resizable } from 'react-resizable';
import { Table } from 'antd';

export const StyledResizable = styled(Resizable)`
  .react-resizable {
    position: relative;
    background-clip: padding-box;
  }

  .react-resizable-handle {
    position: absolute;
    right: -5px;
    bottom: 0;
    z-index: 1;
    width: 10px;
    height: 100%;
    cursor: col-resize;
  }
`

export const StyledTable = styled(Table)`
  .ant-table {
    box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.5);
    -webkit-box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.5);
    -moz-box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.5);
  }

  .ant-table-body {
    height: calc(100vh - 222px) !important;
  }

  .ant-table-tbody>tr>td {
    padding: 5px 10px 5px 10px !important;
  }

  .ant-table-cell {
    /* border: none; */
  }
`

export const LongTextContainer = styled.div`
  /* display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden; */
  overflow-y: auto;
  height: 100px;
  display: flex;
  /* justify-content: center;
  align-items: center; */
`